import { createI18n } from 'vue-i18n';
import getDefaultLanguage from "@/utils/languages/get_default_language"
import zh from './zh/index'
import en from './en/index' 

const i18n = createI18n({
    legacy: false,
    warnHtmlMessage: false,
    locale: getDefaultLanguage(), 
    messages: {
      en,
      zh,
    }
  });

  export default i18n